import * as React from 'react';
import {Alert} from '@material-ui/lab';
import {Element, scroller} from "react-scroll";

interface IProps {
    response: string;
    resultSuccessful: boolean;
}

function scrollToTopOfResults() {
    scroller.scrollTo("update-insurance-result", {
        delay: 0,
        duration: 800,
        offset: -250,
        smooth: "easeInOutQuart",
    });
}

class UpdateInsuranceResult extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <br/>
                <p style={{
                    border: '3px solid lightgray',
                    padding: '5px',
                    whiteSpace: "pre-wrap",
                    wordBreak: "normal",
                    wordWrap: "break-word"
                }}>

                    {this.props.resultSuccessful  &&
                        <Alert variant="filled" severity="info">
                            {this.props.response}
                        </Alert>}

                    {this.props.resultSuccessful && scrollToTopOfResults()}

                    <Element name="update-insurance-result"/>
                </p>
            </div>
        );
    }
}

export default UpdateInsuranceResult;
